import { render } from "./Complete.vue?vue&type=template&id=69bda912"
import script from "./Complete.vue?vue&type=script&lang=js"
export * from "./Complete.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\SanttuLehtinen\\Projektit\\vetera\\vetera-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__